/*
* @Author: Johnny.liu
* @Date:   2021-03-24 13:01:14
* @Last Modified by:   Johnny.liu
* @Last Modified time: 2021-03-24 16:04:39
*/
import template from './approve-commonet.html';
// import {PMAPI, PMENUM} from '../../../lib/postmsg';
import './approve-commonet.scss';

let approveCommonet = {
    template: template,
    data: {
        comment: "",
    },
    binds: [
        {
            event: 'click',
            selector: '.sub-btn',
            callback: function () {
                let commont = this.el.find('#app-info').val();
                PMAPI.sendToSelf({
                    key: this.key,
                    type: PMENUM.close_dialog,
                    data: {
                        type: 'submit',
                        onlyclose: false,
                        commont: commont,
                    }
                })
            }
        },{
            event: 'click',
            selector: '.cal-btn',
            callback: function () {
                console.log('cal', this)
                PMAPI.sendToSelf({
                    key: this.key,
                    type: PMENUM.close_dialog,
                    data: {
                        onlyclose: true
                    }
                })
            }
        },
    ],
    actions: {
        initPage: function(){
        }
    },
    afterRender: function () {
        console.log('this', this.el)
        this.actions.initPage();
    },
    beforeDestory: function () {

    }
};
export default approveCommonet;


// WEBPACK FOOTER //
// app/components/customPage/showRecord/approve-commonet.js